import { render, staticRenderFns } from "./buyMobil.vue?vue&type=template&id=4a253cb0&"
import script from "./buyMobil.vue?vue&type=script&lang=ts&"
export * from "./buyMobil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports